
import axios from "axios";
import TokenService from "./tokenlocalstorage.service";
import notificationService from "services/notification.service";
import authService from "services/auth.service";
import jwt_decode from "jwt-decode";

const axiosClient = axios.create();

// var test = false;

axiosClient.defaults.baseURL = process.env.REACT_APP_AUTH_IP_ADDRESS;
// axiosClient.defaults.baseURL = "http://34.219.48.250:8081/";

axiosClient.defaults.headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
  // Authorization: 'Bearer ' + token
};

//All request will wait 2 seconds before timeout
// axiosClient.defaults.timeout = 2000;

axiosClient.defaults.withCredentials = false;

axiosClient.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (
      token &&
      config.url !== "bss/svc/login" &&
      config.url !== "bss/reset" &&
      config.url !== "bss/sendEmail" &&
      config.url !== "bss/svc/useRefreshToken" &&
      config.url !== "bss/refreshToken"
    ) {
      //config.headers["Authorization"] = "Bearer " + token; // for Spring Boot back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (res) => {
    notificationService.showSuccessResponseNotification(res.config.url);
    return res;
  },
  async (err) => {
    const originalConfig = err.config;
    // notificationService.showErrorResponseNotification(originalConfig.url);
    notificationService.showNonBlacklistedError(
      err?.config?.url,
      err?.response?.data?.message
    );

    //check refresh token is valid or not

    if (
      originalConfig.url !== "/bss/svc/login" &&
      originalConfig.url !== "/bss/refreshToken" &&
      err.response
    ) {
      // Access Token was expired
      if (
        (err.response.status === 0 || err.response.status === 401) &&
        !originalConfig._retry
      ) {
        // originalConfig._retry = true;
        try {
          await refreshToken(true);
          return axiosClient(originalConfig);
        } catch (_error) {
          console.log("-----------------------1234", _error);
          if (_error.response.status === 400) {
            console.log("AM 40000");
            authService.logout();
            window.location.href = "/";
          }
          return Promise.reject(_error);
        }
      }
    } else if (originalConfig.url === "/bss/refreshToken" && err.response) {
      console.log("-----------------------1234", err.response);
      if (
        err.response.status === 0 ||
        err.response.status === 401 ||
        err.response.status === 400
      ) {
        authService.logout();
        window.location.href = "/";
      }
    }

    return Promise.reject(err);
  }
);

export function getRequest(URL) {
  return axiosClient.get(`/${URL}`).then((response) => response.data);
}
export function getRequestWithCancelToken(URL, token) {
  return axiosClient
    .get(`/${URL}`, { cancelToken: token })
    .then((response) => response.data);
}
export function postRequest(URL, payload) {
  return axiosClient.post(`/${URL}`, payload).then((response) => response);
}

export function patchRequest(URL, payload) {
  return axiosClient.patch(`/${URL}`, payload).then((response) => response);
}

export function putRequest(URL, payload) {
  return axiosClient.put(`/${URL}`, payload).then((response) => response);
}

export function deleteRequest(URL) {
  return axiosClient.delete(`/${URL}`).then((response) => response);
}

export async function refreshToken(reload) {
  const token = TokenService.getLocalAccessToken();
  const decodedToken = jwt_decode(token);
  if (decodedToken) {
    if ((decodedToken["exp"] - 20) * 1000 > new Date().getTime()) {
      return;
    }
  }

  const rs = await axiosClient
    .post(
      "/bss/refreshToken",
      {
        refreshToken: TokenService.getLocalRefreshToken(),
      },
      {
        transformRequest: (data, headers) => {
          delete headers?.Authorization;
          return JSON.stringify(data);
        },
      }
    )
    .then((response) => {
      const { accessToken } = response?.data?.data;

      if (response?.data?.data) {
        TokenService.updateLocalAccessToken(response?.data?.data);
        if (reload) {
          window.location.reload();
        }
      } else {
        authService.logout();
        window.location.href = "/";
      }
    });
  // isRefreshing = true;
}

var isRefreshing1 = false;
class Singleton {
  constructor() {
    isRefreshing1 = false;
  }

  async refreshToken(reload) {
    if (isRefreshing1) {
      while (this.isRefreshing1) {
        await new Promise((r) => setTimeout(r, 50));
      }
      return;
    }

    const token = TokenService.getLocalAccessToken();
    const decodedToken = jwt_decode(token);
    if (decodedToken) {
      if ((decodedToken["exp"] - 20) * 1000 > new Date().getTime()) {
        return;
      }
    }
    isRefreshing1 = true;
    await axiosClient
      .post(
        "/bss/refreshToken",
        {
          refreshToken: TokenService.getLocalRefreshToken(),
        },
        {
          transformRequest: (data, headers) => {
            delete headers?.Authorization;
            return JSON.stringify(data);
          },
        }
      )
      .then((response) => {
        //const { accessToken } = response?.data?.data;

        if (response?.data?.data) {
          TokenService.updateLocalAccessToken(response?.data?.data);
          if (reload) {
            window.location.reload();
          }
          isRefreshing1 = false;
        } else {
          authService.logout();
          window.location.href = "/";
          isRefreshing1 = false;
        }
      });
    isRefreshing1 = false;
  }
}

const singletonInstance = new Singleton();

//Object.freeze(singletonInstance);

export default singletonInstance;
